module.exports = __webpack_public_path__ + "img/sigfox.3974ed2e.png";